import * as React from 'react'
import { TaskPlanSpanConnected } from './TaskPlanSpanConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore, MOCK_TASK_A_ID } from 'mockState'

export const TaskPlanSpanExamples = () => {
  return (
    <div className="TaskPlanSpanExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskPlanSpanConnected taskId={MOCK_TASK_A_ID} />
      </Provider>
    </div>
  )
}
